import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.822 2.427l.069-.551A1 1 0 0 1 10.883 1h2.234a1 1 0 0 1 .992.876l.07.551a1.5 1.5 0 0 0 .913 1.2l.64.266a1.5 1.5 0 0 0 1.496-.202l.44-.341a1 1 0 0 1 1.32.082l1.58 1.58a1 1 0 0 1 .082 1.32l-.341.44a1.5 1.5 0 0 0-.202 1.495l.266.64a1.5 1.5 0 0 0 1.2.915l.551.069a1 1 0 0 1 .876.992v2.234a1 1 0 0 1-.876.992l-.551.07a1.5 1.5 0 0 0-1.2.913l-.266.64a1.5 1.5 0 0 0 .202 1.496l.341.44a1 1 0 0 1-.082 1.32l-1.58 1.58a1 1 0 0 1-1.32.082l-.44-.341a1.5 1.5 0 0 0-1.495-.202l-.64.266a1.5 1.5 0 0 0-.915 1.2l-.069.551a1 1 0 0 1-.992.876h-2.234a1 1 0 0 1-.992-.876l-.07-.551a1.5 1.5 0 0 0-.913-1.2l-.64-.266a1.5 1.5 0 0 0-1.496.202l-.44.341a1 1 0 0 1-1.32-.082l-1.58-1.58a1 1 0 0 1-.082-1.32l.341-.44a1.5 1.5 0 0 0 .202-1.495l-.266-.64a1.5 1.5 0 0 0-1.2-.915l-.551-.069A1 1 0 0 1 1 13.117v-2.234a1 1 0 0 1 .876-.992l.551-.07a1.5 1.5 0 0 0 1.2-.913l.266-.64a1.5 1.5 0 0 0-.202-1.496l-.341-.44a1 1 0 0 1 .082-1.32l1.58-1.58a1 1 0 0 1 1.32-.082l.44.341a1.5 1.5 0 0 0 1.495.202l.64-.266a1.5 1.5 0 0 0 .915-1.2zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
});

var SvgGearFilled = function SvgGearFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgGearFilled;